
import { Vue, Prop, Component } from 'vue-property-decorator';
import store from './GraderStore';

@Component
export default class TextEditor extends Vue {
  // TODO: place more restrictions on value of keys inside storeMapping
  @Prop({ required: true }) storeMapping!: {
    [key: string]: string;
  };
  @Prop({ required: true }) extension!: string;
  @Prop({ default: 'NA' }) module!: string;
  @Prop({ default: false }) readOnly!: boolean;

  get theme(): string {
    return store.getters['theme'];
  }

  get filename(): string {
    if (this.storeMapping.module) {
      return `${store.getters[this.storeMapping.module]}.${this.extension}`;
    }
    return `${this.module}.${this.extension}`;
  }

  get contents(): string {
    return store.getters[this.storeMapping.contents];
  }

  set contents(value: string) {
    if (this.readOnly) return;
    store.dispatch(this.storeMapping.contents, value);
  }

  get title(): string {
    return this.filename;
  }
}
